import React, {useState} from 'react';
import {Link, useNavigate} from 'react-router-dom';

export default function Header() {
  const hasToken = document.cookie.split(';').some(c => c.trim().startsWith('jwtToken='));
  const navigate = useNavigate();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => {
    document.cookie = 'jwtToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = 'renewalToken=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    document.cookie = 'displayName=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
    navigate('/login');
  };

  return (
    <header className="bg-white shadow-sm">
      <nav className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center h-20">
          <div className="flex items-center">
            <Link to="/">
              <img src="/images/matterking-logo.png" alt="Matter King" className="h-12 sm:h-16 w-auto" />
            </Link>
          </div>
          <div className="hidden md:flex space-x-8">
            <a href="#home" className="text-gray-700 hover:text-red-600">Home</a>
            <a href="#features" className="text-gray-700 hover:text-red-600">Features</a>
            <a href="#pricing" className="text-gray-700 hover:text-red-600">Pricing</a>
            <a href="#contact" className="text-gray-700 hover:text-red-600">Contact</a>
          </div>
          <div className="hidden sm:flex gap-3">
            {hasToken ? (
              <>
                <Link to="/apps" className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 flex items-center gap-2">
                  <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2V6zM14 6a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2V6zM4 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2H6a2 2 0 01-2-2v-2zM14 16a2 2 0 012-2h2a2 2 0 012 2v2a2 2 0 01-2 2h-2a2 2 0 01-2-2v-2z" />
                  </svg>
                  Apps
                </Link>
                <button onClick={handleLogout} className="bg-white text-red-600 px-6 py-2 rounded-lg border-2 border-red-600 hover:bg-red-50">
                  Sign Out
                </button>
              </>
            ) : (
              <>
                <Link to="/login" className="bg-white text-red-600 px-6 py-2 rounded-lg border-2 border-red-600 hover:bg-red-50">
                  Login
                </Link>
                <button className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700">
                  Sign Up
                </button>
              </>
            )}
          </div>
          <button onClick={() => setMenuOpen(!menuOpen)} className="sm:hidden text-gray-600 hover:text-gray-900">
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d={menuOpen ? "M6 18L18 6M6 6l12 12" : "M4 6h16M4 12h16M4 18h16"} />
            </svg>
          </button>
        </div>
        {menuOpen && (
          <div className="sm:hidden pb-4 border-t border-gray-200 pt-4 space-y-3">
            <a href="#home" className="block text-gray-700 hover:text-red-600">Home</a>
            <a href="#features" className="block text-gray-700 hover:text-red-600">Features</a>
            <a href="#pricing" className="block text-gray-700 hover:text-red-600">Pricing</a>
            <a href="#contact" className="block text-gray-700 hover:text-red-600">Contact</a>
            <div className="flex flex-col gap-2 pt-2">
              {hasToken ? (
                <>
                  <Link to="/apps" className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700 text-center">Apps</Link>
                  <button onClick={handleLogout} className="bg-white text-red-600 px-6 py-2 rounded-lg border-2 border-red-600 hover:bg-red-50">Sign Out</button>
                </>
              ) : (
                <>
                  <Link to="/login" className="bg-white text-red-600 px-6 py-2 rounded-lg border-2 border-red-600 hover:bg-red-50 text-center">Login</Link>
                  <button className="bg-red-600 text-white px-6 py-2 rounded-lg hover:bg-red-700">Sign Up</button>
                </>
              )}
            </div>
          </div>
        )}
      </nav>
    </header>
  );
}
